import { AgRendererComponent } from 'ag-grid-angular';
import { Component, ChangeDetectionStrategy} from '@angular/core';

@Component({ standalone: false,
  selector: 'irb-match-cell',
  template: `<span tooltip [tooltipTitle]="params.data.customToolTipWhenDisabled" [tooltipPosition]="'right'" [tooltipHorizontalOffset]='0'><span [outerHTML]="params.value | decodeHtml | highlight: params.data.match | decodeHtml"></span></span>`,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MatchCustomTooltipComponent implements AgRendererComponent {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
